"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.engine = void 0;

var _apiModels = require("./models/apiModels");

var _config = _interopRequireDefault(require("./config"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

let deferredImport;

const deferred = () => {
  deferredImport || (deferredImport = Promise.resolve().then(() => _interopRequireWildcard(require('./runtimeEngine'))));
  return deferredImport;
};

const app = () => deferred().then(({
  modules
}) => modules.app);

const passForward = (apiName, method) => {
  return (...args) => {
    return deferred().then(({
      modules
    }) => modules[apiName]).then(module => module[method](...args));
  };
};

const composeApi = ({
  base = {},
  methods,
  properties = [],
  name
}) => {
  // Set api base structure
  const api = Object.assign({}, base); // Add methods

  methods.forEach(method => api[method] = passForward(name, method)); // Add properties

  properties.forEach(property => {
    const key = property.includes('/') ? property.split('/')[1] : property;
    Object.defineProperty(api, key, {
      get: () => _config.default.get(property),
      set: value => _config.default.set({
        [property]: value
      })
    });
  });
  return () => api;
};

const appApi = composeApi(_apiModels.appRecipe);
const capabilityApi = composeApi(_apiModels.capabilityRecipe);
const permissions = composeApi(_apiModels.permissionsRecipe);
const pulse = composeApi(_apiModels.pulseRecipe);
const session = composeApi(_apiModels.sessionRecipe);
const settings = composeApi(_apiModels.settingsRecipe);
const shell = composeApi(_apiModels.shellRecipe);
const sidenav = composeApi(_apiModels.sidenavRecipe);
const user = composeApi(_apiModels.userRecipe);

const deferredMethod = method => (...args) => deferred().then(engineModule => engineModule[method](...args));

const engine = {
  app,
  deprecationWarnings: (config, legacyCanTakeover) => deferredMethod('deprecationWarnings')(config, legacyCanTakeover),
  done: timestamp => deferredMethod('done')(timestamp),
  modules: {
    appApi,
    capabilityApi,
    permissions,
    pulse,
    session,
    settings,
    shell,
    sidenav,
    user
  },
  onConfigure: (runtime, config, legacyCanTakeover) => deferredMethod('onConfigure')(runtime, config, legacyCanTakeover),
  onPageChange: runtime => deferredMethod('onPageChange')(runtime),
  onShellUserInput: e => deferredMethod('onShellUserInput')(e),
  preload: preloads => deferredMethod('preload')(preloads),
  waitForInit: runtimeInstance => deferredMethod('waitForInit')(runtimeInstance)
};
exports.engine = engine;